// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1IeV7","title":"InfoRow_title__2Kpeg"};